import { render, staticRenderFns } from "./ReportTestingMethodsFilters.vue?vue&type=template&id=1156c201&scoped=true"
import script from "./ReportTestingMethodsFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportTestingMethodsFilters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReportTestingMethodsFilters.vue?vue&type=style&index=0&id=1156c201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156c201",
  null
  
)

export default component.exports